export const AUTH_CRITERIA = {
  USER_NAME_MIN_LENGTH: 6,
  USER_NAME_MAX_LENGTH: 29,
  FULL_NAME_MIN_LENGTH: 6,
  FULL_NAME_MAX_LENGTH: 32,
  PASSWORD_MIN_LENGTH: 6,
  PASSWORD_MAX_LENGTH: 32,
  PHONE_MIN_LENGTH: 10,
  PHONE_MAX_LENGTH: 11,
  EMAIL_MIN_LENGTH: 4,
  EMAIL_MAX_LENGTH: 50,
  BANK_NAME_MAX_LENGTH: 32,
  BANK_NAME_MIN_LENGTH: 2,
  BANK_NO_MIN_LENGTH: 3,
  BANK_NO_MAX_LENGTH: 19
}
